import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  getMeetingRoomList,
  listAllUnitForMeetingForRoomCheck,
} from "../../redux/actions/meetingRoomAction/meetingRoomAction";
import { useSelector, useDispatch } from "react-redux";
import CommonStepper from "../Common/CommonStepper";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getImmediateFollowOnMeetingDetails,
  setErrorMessage,
  updateIsCreateMeetingProcessed,
  updateIsNewMeetingPage,
  updateMeetingDetails,
  updateStep,
} from "../../redux/actions/meetingActions/MeetingAction";
import * as constantMessages from "../../constants/constatntMessages";
import "../Login/style/Login.css";
import LoaderButton from "../Common/LoaderButton";
import AddAttendees from "./AddAttendees";
import AddAgendas from "./AddAgendas";
import "react-toastify/dist/ReactToastify.css";
import {
  logOut,
  setInValidUser,
} from "../../redux/actions/authActions/authAction";
import { checkCharacterLeft, cleanInput } from "../../helpers/commonHelpers";
import { textBoxStrLength } from "../../config/config";
import Select from "react-select";
import ConfirmModal from "./ConfirmModal";
import { toast } from "react-toastify";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { handleApiError } from "../../helpers/errorResponseHelper";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const EditMeeting = React.memo(() => {
  const [isAmPm, setIsAmPm] = useState(null);

  useEffect(() => {
    const testTime = new Date().toLocaleTimeString();
    const is12Hour = testTime.includes("AM") || testTime.includes("PM");

    setIsAmPm(is12Hour);
  }, []);
  const employeeData = useSelector((state) => state.user);
  const regularExpressionForAgendaTitle =
    /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const meetingRoomData = useSelector((state) => state.meetingRoom);
  const meetingData = useSelector((state) => state.meeting);
  const organizationData = useSelector((state) => state.organization);
  const zoomCred =
    organizationData?.organizationData?.hostingDetails?.zoomCredentials;
  const gmeetCred =
    organizationData?.organizationData?.hostingDetails?.gMeetCredentials;
  const msTeamsCred =
    organizationData?.organizationData?.hostingDetails?.msTeamCredentials;
  const [selectedRoomOption, setSelectedRoomOption] = useState([
    { label: "Select Room", value: "" },
  ]);
  const [selectedUnitOption, setSelectedUnitOption] = useState([
    { label: "Select Unit", value: "" },
  ]);
  const [roomErrors, setRoomErrors] = useState({});

  const [step, setStep] = useState(0);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isUpdateDiable, setIsUpdateDiable] = useState(false);

  const [confirmMessage, setConfirmMessage] = useState(
    "Do you want to save the changes ?"
  );
  const [confirmTitle, setConfirmTitle] = useState("Update Meeting");
  const [errors, setErrors] = useState({});
  const [unitId, setUnitId] = useState(null);
  const [zoomError, setZoomError] = useState(null);
  const [isPreviousChildMeetingAvailable, setIsPreviousChildMeetingAvailable] =
    useState(false);
  const [previousChildMeetingData, setPreviousChildMeetingData] =
    useState(null);
  const [formData, setFormData] = useState({
    title: "",
    mode: "physical",
    location: "manual",
    date: "",
    link: "",
    fromTime: "",
    toTime: "",
    roomId: "",
    locationData: "",
    linkType: null,
  });
  const location = useLocation();

  const stateData = location.state;

  useEffect(() => {
    if (meetingData?.singleMeetingDetails?.parentMeetingId) {
      const fetchData = async () => {
        const payload = {
          id: meetingData?.singleMeetingDetails?._id,
          parentMeetingId: meetingData?.singleMeetingDetails?.parentMeetingId,
        };

        const result = await dispatch(
          getImmediateFollowOnMeetingDetails(payload, accessToken)
        );

        if (result !== null) {
          // Do something with the result here
          setIsPreviousChildMeetingAvailable(true);
          setPreviousChildMeetingData(result);
        } else {
          setIsPreviousChildMeetingAvailable(false);
          if (
            meetingData?.singleMeetingDetails.parentMeetingDetails &&
            meetingData?.singleMeetingDetails?.parentMeetingDetails?.length !==
              0
          ) {
            setPreviousChildMeetingData(
              meetingData?.singleMeetingDetails?.parentMeetingDetails[0]
            );
          }
        }
      };

      fetchData(); // call the async function
    } else {
      if (
        meetingData?.singleMeetingDetails &&
        meetingData?.singleMeetingDetails?.parentMeetingDetails?.length !== 0
      ) {
        setPreviousChildMeetingData(
          meetingData?.singleMeetingDetails?.parentMeetingDetails[0]
        );
      }
    }
    return () => {
      setIsPreviousChildMeetingAvailable(false);
      setPreviousChildMeetingData(null);
    };
  }, [meetingData?.singleMeetingDetails]);

  useEffect(() => {
    if (formData.toTime) {
      toDateFieldValidationCheck(formData.toTime);
    }
  }, [formData.toTime]); // Runs whenever toTime updates
  useEffect(() => {
    if (formData.fromTime) {
      if (previousChildMeetingData) {
        fromDateFieldValidationCheckForPrevious();
      } else {
        fromDateFieldValidationCheck();
      }
    }
  }, [formData.fromTime]);

  useEffect(() => {
    dispatch(updateIsNewMeetingPage(false));
    if (stateData?.isMeetingDataUpdate) {
      document.title = "Edit Meeting: MinutesVault";
    }

    if (meetingData?.singleMeetingDetails?.date) {
      var date = new Date(meetingData?.singleMeetingDetails?.date);
      var dateString = new Date(
        date?.getTime() - date?.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
    }

    setStep(meetingData.step + 1);
    if (meetingData.singleMeetingDetails && stateData.isMeetingDataUpdate) {
      setFormData({
        ...formData,
        title: meetingData.singleMeetingDetails.title,
        mode: meetingData.singleMeetingDetails.mode.toLowerCase(),
        location: meetingData.singleMeetingDetails.locationDetails.isMeetingRoom
          ? "meetingroom"
          : "manual",

        link: meetingData.singleMeetingDetails.link
          ? meetingData.singleMeetingDetails.link
          : "",
        toTime: meetingData?.singleMeetingDetails?.actualToTime,
        fromTime: meetingData?.singleMeetingDetails?.actualFromTime,
        roomId: meetingData.singleMeetingDetails.locationDetails.roomId,
        locationData: meetingData.singleMeetingDetails.locationDetails.location
          ? meetingData.singleMeetingDetails.locationDetails.location
          : "",
        date: dateString ? dateString : null,
        linkType: meetingData?.singleMeetingDetails?.linkType
          ? meetingData?.singleMeetingDetails?.linkType
          : meetingData?.singleMeetingDetails?.hostDetails?.hostType
            ? meetingData?.singleMeetingDetails?.hostDetails?.hostType
            : null,
      });
      if (
        (meetingData.singleMeetingDetails.locationDetails.isMeetingRoom &&
          meetingData.step === 1) ||
        3
      ) {
        const unitPayload = {
          organizationId: userData.organizationId,
        };
        dispatch(listAllUnitForMeetingForRoomCheck(unitPayload, accessToken));
        if (meetingData?.singleMeetingDetails?.unitDetail) {
          const payload = {
            unitId: meetingData?.singleMeetingDetails?.unitDetail?._id,
            organizationId: userData?.organizationId,
          };

          dispatch(getMeetingRoomList(payload, accessToken));
        }
      }

      if (meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom) {
        setSelectedRoomOption({
          value: meetingData.singleMeetingDetails?.roomDetail[0]._id,
          label: meetingData.singleMeetingDetails?.roomDetail[0].title,
          name: "roomId",
        });
        if (meetingData?.singleMeetingDetails?.unitDetail) {
          setSelectedUnitOption({
            value: meetingData.singleMeetingDetails?.unitDetail._id,
            label: meetingData.singleMeetingDetails?.unitDetail.name,
            name: "unitId",
          });
          setUnitId(meetingData.singleMeetingDetails?.unitDetail._id);
        }
      }
      if (
        meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom ===
        false
      ) {
        setSelectedRoomOption([{ label: "*Select Room", value: "" }]);
        setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      }
    }
    return () => {
      setFormData({
        ...formData,
        title: "",
        mode: "physical",
        location: "manual",
        date: "",
        link: "",
        fromTime: "",
        toTime: "",
        roomId: "",
        locationData: "",
      });
    };
  }, [meetingData.step, meetingData.singleMeetingDetails]);

  const fromDateFieldValidationCheckForPrevious = (e) => {
    setErrors({});

    const errors = {};
    if (!formData?.fromTime?.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (previousChildMeetingData?.actualToTime) {
      const parentMeetingToTime = previousChildMeetingData?.actualToTime;

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];

      const mDate = dayjs(formData.date).format("YYYY-MM-DD");

      if (
        mDate ===
        dayjs.utc(previousChildMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }

      if (formData?.toTime?.trim()) {
        const fromTimeArray = formData.fromTime.split(":");
        const fromTimeHour = fromTimeArray[0];
        const fromTimeMinute = fromTimeArray[1];
        const toTimeArray = formData.toTime.split(":");
        const toTimeHour = toTimeArray[0];
        const toTimeMinute = toTimeArray[1];

        if (fromTimeHour > toTimeHour) {
          errors.fromTime = constantMessages.invalidFromHour;
        } else if (
          fromTimeHour === toTimeHour &&
          fromTimeMinute >= toTimeMinute
        ) {
          errors.fromTime = constantMessages.invalidFromMinute;
        }
      }
    } else if (formData?.toTime?.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }

    setErrors(errors);
  };
  const handledateChange = async (name, value) => {
    dispatch(setErrorMessage(null));

    setErrors({});
    if (value) {
      let formattedValue = value; // Default to the provided value
      let errors = {};
      // Ensure the value is formatted correctly if it's a Day.js object

      if (dayjs.isDayjs(value)) {
        if (name === "date") {
          formattedValue = dayjs(value)?.format("YYYY-MM-DD");

          const mDate = dayjs(value)?.format("YYYY-MM-DD");
          const previousChildMeetingDataActualDate = dayjs(
            previousChildMeetingData?.actualDate
          )?.format("YYYY-MM-DD");

          if (previousChildMeetingData?.actualDate) {
            if (
              mDate <
              dayjs
                .tz(previousChildMeetingData?.actualDate, "UTC")
                .format("YYYY-MM-DD")
            ) {
              errors.date =
                isPreviousChildMeetingAvailable === false
                  ? constantMessages.invalidFollowOnMeetingDate
                  : constantMessages.invalidFollowOnMeetingDateForPreviousMeeting;
            }
          }
          if (previousChildMeetingData?.actualFromTime) {
            if (
              mDate ===
                dayjs
                  .tz(previousChildMeetingData?.actualDate, "UTC")
                  .format("YYYY-MM-DD") &&
              formData.fromTime <= previousChildMeetingData?.actualToTime
            ) {
              errors.fromTime =
                isPreviousChildMeetingAvailable === false
                  ? constantMessages.invalidFromMinuteForParentMeeting
                  : constantMessages.invalidFromMinuteForPreviousMeeting;
            }
          }
          setErrors(errors);
        } else if (name.includes("Time")) {
          formattedValue = value.format("HH:mm"); //  Store Time in 24-hour format

          setErrors(errors);
        }
      }

      setFormData((prev) => {
        const updatedFormData = { ...prev, [name]: formattedValue };
        return updatedFormData;
      });
    }
  };

  const handleRoomChange = async (e) => {
    dispatch(setErrorMessage(null));
    setErrors({});
    dispatch(updateIsCreateMeetingProcessed(false));
    setRoomErrors({});
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedRoomOption(e);
    if (!formData.date || !formData.fromTime || !formData.toTime) {
      return;
    }
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/meeting/check-meetingroom-availability`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };
      const payload = {
        roomId: value,
        date: formData.date,
        fromTime: formData.fromTime,
        toTime: formData.toTime,
        organizationId: userData.organizationId,
        meetingId: meetingData.singleMeetingDetails?._id
          ? meetingData.singleMeetingDetails?._id
          : undefined,
      };
      const response = await axios.post(webApiUrl, payload, headerObject);
      const resData = response.data;
      if (resData.success === false) {
        setRoomErrors((prevErrors) => ({
          ...prevErrors,
          room: resData.message,
        }));
      } else {
        setRoomErrors({});
      }
    } catch (error) {
      if (handleApiError(error)) return;
      setErrors(error.response?.data?.message);
    }
  };

  const handleRoomChangeForDate = async (e) => {
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});
    const { name, value } = e.target;

    if (!formData.roomId) {
      return;
    }
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/meeting/check-meetingroom-availability`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };
      const payload = {
        roomId: formData.roomId,
        date: name === "date" ? value : formData.date,
        fromTime: name === "fromTime" ? value : formData.fromTime,
        toTime: name === "toTime" ? value : formData.toTime,
        organizationId: userData.organizationId,
      };
      const response = await axios.post(webApiUrl, payload, headerObject);
      const resData = response.data;
      if (resData.success === false) {
        setRoomErrors((prevErrors) => ({
          ...prevErrors,
          room: resData.message,
        }));
      } else {
        setRoomErrors({});
      }
    } catch (error) {
      if (handleApiError(error)) return;
      setErrors(error.response?.data?.message);
    }
  };

  const submitMeetingDetails = async (e) => {
    e.preventDefault();

    let sendNotification = false;
    let reScheduled = false;

    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (formData.linkType === "ZOOM" && zoomError) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        zoomError: zoomError,
      }));
      return;
    }

    if (
      Object.keys(roomErrors).length !== 0 ||
      meetingData?.errorMessage !== null
    ) {
      setErrors(newErrors);
      return;
    }

    dispatch(setErrorMessage(null));
    setRoomErrors({});

    if (Object.keys(newErrors).length === 0) {
      let locationDetails = {};
      if (formData.location === "meetingroom") {
        locationDetails["isMeetingRoom"] = true;
        locationDetails["roomId"] = formData.roomId;
      } else {
        locationDetails["isMeetingRoom"] = false;
        locationDetails["location"] = formData.locationData;
      }

      if (meetingData.singleMeetingDetails || stateData.isMeetingDataUpdate) {
        const meetingId = meetingData?.singleMeetingDetails?._id;
        const payload = {
          isEditMeeting: stateData.isMeetingDataUpdate
            ? stateData.isMeetingDataUpdate
            : false,
          date: new Date(formData.date),
          locationDetails,
          organizationId: userData.organizationId,
          mode: formData.mode.toUpperCase(),
          fromTime: formData.fromTime,
          toTime: formData.toTime,
          title: cleanInput(formData.title),
          link: formData.link,
          step: 1,
          sendNotification,
          reScheduled,
          isUpdate:
            stateData.isMeetingDataUpdate &&
            meetingData.singleMeetingDetails.step === 3
              ? true
              : false,

          linkType: formData.linkType ? formData.linkType : undefined,
        };
        const fromUpdate =
          meetingData?.singleMeetingDetails?.step === 3 ? true : false;

        const result = await dispatch(
          updateMeetingDetails(
            meetingId,
            payload,
            accessToken,
            "updateMeeting",
            false,
            false,
            true
          )
        );
        if (result?.status) {
          setIsUpdateDiable(true);
        }
      }

      if (meetingData.isSuccess) {
        setStep(2);
      }
    }
  };

  const submitMeetingDetailsByConfirmModal = async () => {
    let sendNotification = false;
    let reScheduled = false;
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let locationDetails = {};
      if (formData.location === "meetingroom") {
        locationDetails["isMeetingRoom"] = true;
        locationDetails["roomId"] = formData.roomId;
      } else {
        locationDetails["isMeetingRoom"] = false;
        locationDetails["location"] = formData.locationData;
      }

      if (meetingData.singleMeetingDetails || stateData.isMeetingDataUpdate) {
        const meetingId = meetingData?.singleMeetingDetails?._id;
        const payload = {
          isEditMeeting: stateData.isMeetingDataUpdate
            ? stateData.isMeetingDataUpdate
            : false,
          date: new Date(formData.date),
          locationDetails,
          organizationId: userData.organizationId,
          mode: formData.mode.toUpperCase(),
          fromTime: formData.fromTime,
          toTime: formData.toTime,
          title: cleanInput(formData.title),
          link: formData.link,
          step: 1,
          sendNotification,
          reScheduled,
          isUpdate:
            stateData.isMeetingDataUpdate &&
            meetingData.singleMeetingDetails.step === 3
              ? true
              : false,

          linkType: formData.linkType ? formData.linkType : undefined,
        };

        const result = await dispatch(
          updateMeetingDetails(
            meetingId,
            payload,
            accessToken,
            "updateMeeting",
            false,
            false,
            false
          )
        );
        if (result?.status) {
          setIsUpdateDiable(true);
        }
      }

      if (meetingData.isSuccess) {
        setStep(2);
      }
    } else {
      console.log(newErrors);
    }
  };

  const handleUnitChange = (e) => {
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});
    setRoomErrors({});
    const { name, value } = e;
    setUnitId(value);
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedUnitOption(e);
    const payload = {
      organizationId: userData.organizationId,
      unitId: value,
    };

    dispatch(getMeetingRoomList(payload, accessToken));

    setFormData({
      ...formData,
      roomId: "",
    });
    setSelectedRoomOption([{ label: "Select Room", value: "" }]);
  };

  const handleChange = (e) => {
    dispatch(setErrorMessage(null));
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});
    const { name, value } = e.target;

    if (name === "date" || name === "fromTime" || name === "toTime") {
      handleRoomChangeForDate(e);
    }

    if (name === "locationData") {
      if (value.length <= textBoxStrLength) {
        setFormData({
          ...formData,

          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,

        [name]: value,
      });
    }
    if (value === "manual") {
      dispatch(setErrorMessage(null));
      setRoomErrors({});
    }

    if (value === "meetingroom") {
      const payload = {
        organizationId: userData.organizationId,
      };
      dispatch(listAllUnitForMeetingForRoomCheck(payload, accessToken));
    }

    if (!meetingData?.singleMeetingDetails?.unitDetail) {
      if (employeeData?.userData?.unitDetails) {
        setUnitId(employeeData?.userData?.unitDetails?._id);

        const payload = {
          organizationId: userData.organizationId,
          unitId: employeeData?.userData?.unitDetails?._id,
        };
        setSelectedUnitOption(e);
        dispatch(getMeetingRoomList(payload, accessToken));
        setSelectedUnitOption([
          {
            label: employeeData?.userData?.unitDetails?.name,
            value: employeeData?.userData?.unitDetails?._id,
          },
        ]);
        setSelectedRoomOption([{ label: "*Select Room", value: "" }]);
      } else {
        setUnitId(null);
        setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      }
    }
    if (name === "mode" && value === "physical") {
      setFormData({
        ...formData,
        linkType: "MANUAL",
        link: "",
        mode: value,
      });
    }
    if (name === "mode" && value === "virtual") {
      setFormData({
        ...formData,
        linkType: null,
        link: formData.link,
        mode: value,
      });
    }
    if (name === "mode" && value === "virtual" && !formData.link) {
      setFormData({
        ...formData,
        linkType: "MANUAL",
        link: meetingData.singleMeetingDetails.link
          ? meetingData.singleMeetingDetails.link
          : "",
        mode: value,
      });
    }
    if (name === "title") {
      titleFieldValidationCheck();
    }
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.title.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (!regularExpressionForAgendaTitle.test(cleanInput(data.title))) {
      errors.title = constantMessages.titleRegexError;
    } else if (data.title.trim().length < 5 || data.title.trim().length > 100) {
      errors.title = constantMessages.stringLengthError;
    }

    if (data.locationData.trim()) {
      if (!regularExpressionForAgendaTitle.test(data.locationData)) {
        errors.locationData = constantMessages.titleRegexError;
      } else if (
        data.locationData.trim().length < 3 ||
        data.title.trim().length > 500
      ) {
        errors.locationData = constantMessages.largeStringLengthError;
      }
    }

    if (!formData.date.trim()) {
      errors.date = constantMessages.dateRequired;
    }

    if (previousChildMeetingData?.actualDate) {
      const mDate = dayjs(formData.date, "YYYY-MM-DD");

      if (
        mDate.format("YYYY-MM-DD") <
        dayjs.utc(previousChildMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        errors.date =
          isPreviousChildMeetingAvailable === false
            ? constantMessages.invalidFollowOnMeetingDateForParentMeeting
            : constantMessages.invalidFollowOnMeetingDateForPreviousMeeting;
      }
    }

    if (!data.fromTime.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    }

    if (previousChildMeetingData?.actualToTime) {
      const parentMeetingToTime = previousChildMeetingData?.actualToTime;

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];

      const mDate = dayjs(formData.date, "YYYY-MM-DD");

      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs.utc(previousChildMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }
    } else if (formData.toTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (fromTimeHour === toTimeHour && fromTimeMinute > toTimeMinute) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }
    if (!data.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }

    if (data?.location === "meetingroom") {
      if (!unitId) {
        errors.unitId = constantMessages.unitRequired;
      }

      if (!data?.roomId?.trim()) {
        errors.roomId = constantMessages.roomRequired;
      }
    } else {
      if (data.location === "meetingroom") {
        if (!unitId?.trim()) {
          errors.unitId = constantMessages.unitRequired;
        }
        if (!data?.roomId?.trim()) {
          errors.roomId = constantMessages.roomRequired;
        }
      } else {
        if (!data?.locationData?.trim()) {
          errors.locationData = constantMessages.locationRequired;
        } else if (!regularExpressionForAgendaTitle.test(data.locationData)) {
          errors.locationData = constantMessages.invalidInput;
        }
      }
    }

    if (
      formData?.mode?.trim() === "virtual" &&
      formData?.linkType === "MANUAL"
    ) {
      if (!formData?.link?.trim()) {
        errors.link = constantMessages.linkRequired;
      }
    }

    if (formData?.mode?.trim() === "virtual") {
      if (!formData?.linkType) {
        errors.linkType = "Please add link type";
      }
    }

    const regexp =
      /^(?:(?:https?:)?\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (formData?.link?.trim()) {
      if (!regexp.test(formData?.link?.trim())) {
        errors.link = constantMessages.invalidLink;
      }
    }
    setErrors(errors);
    return errors;
  };

  const fromDateFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.fromTime.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (
      meetingData?.singleMeetingDetails?.parentMeetingDetails[0]?.actualToTime
    ) {
      const parentMeetingToTime =
        meetingData?.singleMeetingDetails?.parentMeetingDetails[0]
          ?.actualToTime;

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];

      const mDate = dayjs(formData.date, "YYYY-MM-DD");

      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs(
          meetingData?.singleMeetingDetails?.parentMeetingDetails[0]?.actualDate
        ).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime = constantMessages.invalidFollowOnMeetingFromHour;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }
      if (formData.toTime.trim()) {
        const fromTimeArray = formData.fromTime.split(":");
        const fromTimeHour = fromTimeArray[0];
        const fromTimeMinute = fromTimeArray[1];
        const toTimeArray = formData.toTime.split(":");
        const toTimeHour = toTimeArray[0];
        const toTimeMinute = toTimeArray[1];

        if (fromTimeHour > toTimeHour) {
          errors.fromTime = constantMessages.invalidFromHour;
        } else if (
          fromTimeHour === toTimeHour &&
          fromTimeMinute >= toTimeMinute
        ) {
          errors.fromTime = constantMessages.invalidFromMinute;
        }
      }
    } else if (formData.toTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];
      if (
        formData?.date ===
        meetingData?.singleMeetingDetails?.parentMeetingDetails[0]?.actualDate
      ) {
        if (fromTimeHour > toTimeHour) {
          errors.fromTime = constantMessages.invalidFromHour;
        } else if (
          fromTimeHour === toTimeHour &&
          fromTimeMinute >= toTimeMinute
        ) {
          errors.fromTime = constantMessages.invalidFromMinute;
        }
      }
    }
    setErrors(errors);
  };

  const locationDetailsFieldValidationCheck = (e) => {
    const errors = {};

    if (formData.location === "meetingroom") {
      if (!unitId?.trim()) {
        errors.unitId = constantMessages.unitRequired;
      }
      if (!formData?.roomId?.trim()) {
        errors.roomId = constantMessages.roomRequired;
      }
    } else {
      if (!formData?.locationData?.trim()) {
        errors.locationData = constantMessages.locationRequired;
      } else if (!regularExpressionForAgendaTitle.test(formData.locationData)) {
        errors.locationData = constantMessages.invalidInput;
      } else if (
        formData.locationData.trim().length < 3 ||
        formData.title.trim().length > 500
      ) {
        errors.locationData = constantMessages.largeStringLengthError;
      }
    }
    setErrors(errors);
  };

  const toDateFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }
    setErrors(errors);
  };

  const dateFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.date.trim()) {
      errors.date = constantMessages.dateRequired;
    } else if (
      meetingData?.singleMeetingDetails?.parentMeetingDetails[0]?.actualDate
    ) {
      const actualDate =
        meetingData?.singleMeetingDetails?.parentMeetingDetails[0]?.actualDate;
      const inputDate = new Date(formData.date);

      const parentMeetingDate = new Date(actualDate);

      let differenceInTime = inputDate.getTime() - parentMeetingDate.getTime();
      let differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));

      differenceInDays =
        differenceInDays === 0 ? differenceInDays + 1 : differenceInDays;

      if (differenceInDays < 0) {
        errors.date = constantMessages.invalidDate;
      }
    }

    setErrors(errors);
  };
  const titleFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.title.trim()) {
      errors.title = constantMessages.titleRequired;
      setErrors(errors);
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.titleRegexError;
      setErrors(errors);
    } else if (
      formData.title.trim().length < 5 ||
      formData.title.trim().length > 100
    ) {
      errors.title = constantMessages.stringLengthError;
      setErrors(errors);
    }
  };

  const meetinRoomFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.roomId) {
      errors.roomId = constantMessages.roomRequired;
      setErrors(errors);
    }
    if (!unitId) {
      errors.unitId = constantMessages.unitRequired;
      setErrors(errors);
    }
  };

  const urlFieldValidationCheck = (e) => {
    const errors = {};
    const regexp =
      /^(?:(?:https?:)?\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (formData.link.trim()) {
      if (!regexp.test(formData.link.trim())) {
        errors.link = constantMessages.invalidLink;
        setErrors(errors);
      }
    }
  };

  if (meetingRoomData?.meetingRoomList?.length !== 0) {
    var roomOptions = meetingRoomData?.meetingRoomList?.map((room) => {
      const returnData = {
        value: room._id,
        label: room.title,
        name: "roomId",
      };

      return returnData;
    });
  }

  if (meetingRoomData?.unitList?.length !== 0) {
    var unitOptions = meetingRoomData?.unitList?.map((unit) => {
      const returnData = {
        value: unit._id,
        label: unit.name,
        name: "unitId",
      };

      return returnData;
    });
  }

  const stepCount = meetingData.isNewMeetingPage
    ? 1
    : meetingData?.singleMeetingDetails?.step;

  const updateStepWithCheck = () => {
    const locationData = meetingData.singleMeetingDetails.locationDetails
      .location
      ? meetingData.singleMeetingDetails.locationDetails.location
      : "";
    const location = meetingData?.singleMeetingDetails?.locationDetails
      ?.isMeetingRoom
      ? "meetingroom"
      : "manual";
    const link = meetingData.singleMeetingDetails.link
      ? meetingData.singleMeetingDetails.link
      : "";
    const linkType = meetingData?.singleMeetingDetails?.linkType
      ? meetingData?.singleMeetingDetails?.linkType
      : meetingData?.singleMeetingDetails?.hostDetails?.hostType
        ? meetingData?.singleMeetingDetails?.hostDetails?.hostType
        : null;
    if (
      formData?.title === meetingData?.singleMeetingDetails?.title &&
      formData?.mode ===
        meetingData?.singleMeetingDetails?.mode?.toLowerCase() &&
      formData?.location === location &&
      formData?.link === link &&
      ((meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom ===
        false &&
        meetingData?.singleMeetingDetails?.locationDetails?.location ===
          formData?.locationData) ||
        (meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom ===
          true &&
          meetingData?.singleMeetingDetails?.locationDetails?.roomId ===
            formData?.roomId)) &&
      formData?.linkType === linkType
    ) {
      dispatch(updateStep(1));
    } else {
      setIsConfirmModalOpen(true);
    }
  };

  const handleConfirmSubmit = (status) => {
    if (status) {
      const newErrors = validateForm(formData);

      setErrors(newErrors);
      if (Object.keys(newErrors)?.length === 0) {
        submitMeetingDetailsByConfirmModal();

        setIsConfirmModalOpen(false);
      } else {
        setIsConfirmModalOpen(false);
      }
    } else {
      dispatch(updateStep(1));
      setIsConfirmModalOpen(false);
    }
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: 100,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 100,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
  };

  useEffect(() => {
    const location = meetingData?.singleMeetingDetails?.locationDetails
      ?.isMeetingRoom
      ? "meetingroom"
      : "manual";
    const link = meetingData?.singleMeetingDetails?.link
      ? meetingData?.singleMeetingDetails?.link
      : "";
    const linkType = meetingData?.singleMeetingDetails?.linkType
      ? meetingData?.singleMeetingDetails?.linkType
      : meetingData?.singleMeetingDetails?.hostDetails?.hostType
        ? meetingData?.singleMeetingDetails?.hostDetails?.hostType
        : null;
    if (
      formData?.title === meetingData?.singleMeetingDetails?.title &&
      formData?.mode ===
        meetingData?.singleMeetingDetails?.mode?.toLowerCase() &&
      formData?.location === location &&
      formData?.link === link &&
      ((meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom ===
        false &&
        meetingData?.singleMeetingDetails?.locationDetails?.location ===
          formData?.locationData) ||
        (meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom ===
          true &&
          meetingData?.singleMeetingDetails?.locationDetails?.roomId ===
            formData?.roomId)) &&
      formData?.linkType === linkType

     
    ) {
      setIsUpdateDiable(true);
    } else {
      setIsUpdateDiable(false);
    }

  }, [
    formData?.title,
    formData?.mode,
    formData?.location,
    formData?.link,
    formData?.linkType,
    formData?.locationData,
    formData?.roomId,
  ]);


  return (
    <div className="mt-2 details-form add-meetings">
      <ConfirmModal
        message={confirmMessage}
        title={confirmTitle}
        buttonName={"Cancel"}
        isCalledFromOthers={true}
        setIsConfirmModalOpen={setIsConfirmModalOpen}
        isConfirmModalOpen={isConfirmModalOpen}
        handleConfirmSubmit={handleConfirmSubmit}
      />
      <CommonStepper step={stepCount} fromEditMeeting={true} />
      <br></br>

      {meetingData?.step + 1 == 1 ||
      meetingData?.isNewMeetingPage === true ||
      (stateData?.isMeetingDataUpdate && meetingData?.step === 3) ? (
        <form className="mt-0 p-0 details-form" onSubmit={submitMeetingDetails}>
          <div className="inner-detail-form">
            {previousChildMeetingData && (
              <>
                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">
                        {isPreviousChildMeetingAvailable
                          ? "Previous Meeting ID"
                          : "Parent Meeting ID"}
                      </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>{previousChildMeetingData?.meetingId}</p>
                    </div>
                  </div>
                </div>
                <div className="form-group ">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">
                        {isPreviousChildMeetingAvailable
                          ? "Previous Meeting Title"
                          : "Parent Meeting Title"}
                      </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>{previousChildMeetingData?.title}</p>
                    </div>
                  </div>
                </div>
              
                <div className="minutes-border"></div>
              </>
            )}

            <div className="mb-3">
              <label className="mb-1" for="title">
                Title
              </label>
              <span className="star-mark">*</span>

              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter Meeting Title"
                onBlur={titleFieldValidationCheck}
                onKeyUp={titleFieldValidationCheck}
              />
              {errors.title && (
                <span className="error-message">{errors.title}</span>
              )}
            </div>

            <div className="mb-3">
              <div className="row">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="position-relative resp-input-margin-bottom">
                      <label className="mb-1 input-date">Date</label>
                      <span className="star-mark">*</span>
                      <DatePicker
                        name="date"
                        disabled={
                          meetingData?.singleMeetingDetails?.meetingStatus
                            ?.status !== "draft"
                        }
                        value={formData.date ? dayjs(formData.date) : null}
                        onChange={(newValue) =>
                          handledateChange("date", newValue)
                        }
                        className="svgg"
                        onBlur={dateFieldValidationCheck}
                        format="DD-MM-YYYY"
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            fullWidth: true,
                            size: "small",
                            placeholder: "dd-mm-yyyy",
                            inputProps: {
                              onDragStart: (e) => e.preventDefault(),
                              onDrop: (e) => e.preventDefault(),
                              onDragOver: (e) => e.preventDefault(),
                            },
                          },
                          day: (params) => ({
                            sx: {
                              backgroundColor: dayjs().isSame(params.day, "day")
                                ? ""
                                : "inherit",
                              color: dayjs().isSame(params.day, "day")
                                ? "blue"
                                : "inherit",
                              borderRadius: "0%",
                              "&:hover": {
                                backgroundColor: dayjs().isSame(
                                  params.day,
                                  "day"
                                ),
                              },
                            },
                          }),
                        }}
                      />
                    </div>
                    {errors.date && (
                      <span className="error-message">{errors.date}</span>
                    )}
                  </div>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div className="position-relative resp-input-margin-bottom">
                      <label className="mb-1">From Time</label>
                      <span className="star-mark">*</span>
                      <TimePicker
                        name="fromTime"
                        value={
                          formData.fromTime
                            ? dayjs(`2000-01-01T${formData.fromTime}`)
                            : null
                        }
                        onChange={(newValue) =>
                          handledateChange("fromTime", newValue)
                        }
                        onBlur={fromDateFieldValidationCheck}
                        ampm={true}
                        disabled={
                          meetingData?.singleMeetingDetails?.meetingStatus
                            ?.status !== "draft"
                        }
                        timeSteps={{ minutes: 1 }}
                        format="HH:mm"
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            fullWidth: true,
                            size: "small",
                            placeholder: "hh:mm",
                            inputProps: {
                              onDragStart: (e) => e.preventDefault(),
                              onDrop: (e) => e.preventDefault(),
                              onDragOver: (e) => e.preventDefault(),
                            },
                          },
                        }}
                      />
                    </div>
                    {errors.fromTime && (
                      <span className="error-message">{errors.fromTime}</span>
                    )}
                  </div>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div className="position-relative resp-input-margin-bottom">
                      <label className="mb-1">To Time</label>
                      <span className="star-mark">*</span>
                      <TimePicker
                        name="toTime"
                        value={
                          formData.toTime
                            ? dayjs(`2000-01-01T${formData.toTime}`)
                            : null
                        }
                        onChange={(newValue) =>
                          handledateChange("toTime", newValue)
                        }
                        disabled={
                          meetingData?.singleMeetingDetails?.meetingStatus
                            ?.status !== "draft"
                        }
                        ampm={true}
                        timeSteps={{ minutes: 1 }}
                        format="HH:mm"
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            fullWidth: true,
                            size: "small",
                            placeholder: "hh:mm",
                            inputProps: {
                              onDragStart: (e) => e.preventDefault(),
                              onDrop: (e) => e.preventDefault(),
                              onDragOver: (e) => e.preventDefault(),
                            },
                          },
                        }}
                      />
                    </div>
                    {errors.toTime && (
                      <span className="error-message">{errors.toTime}</span>
                    )}
                  </div>
                </LocalizationProvider>
              </div>
              {previousChildMeetingData ? (
                <div className="d-flex align-items-center text-secondary fs-12 mt-2 font-italic">
                  <span>Previous Meeting Date & Time: &nbsp;</span>
                  <p className="text-secondary fs-12">
                    {" "}
                    {previousChildMeetingData?.date},{" "}
                    {previousChildMeetingData?.fromTime} to{" "}
                    {previousChildMeetingData?.toTime}
                  </p>
                </div>
              ) : null}


              {errors.zoomError && (
                <span className="error-message">{errors.zoomError}</span>
              )}
            </div>
            <div className="mb-3">
              <label className="mb-1">Meeting Mode</label>
              <span className="star-mark">*</span>
              <div className="w-100 resp-grid">
                <div className="form-check form-check-inline">
                  <input
                    id="virtualMode"
                    className="form-check-input"
                    type="radio"
                    name="mode"
                    value="virtual"
                    onChange={handleChange}
                    checked={formData.mode === "virtual"}
                  />
                  <label htmlFor="virtualMode" className="form-check-label">
                    Virtual Meeting
                  </label>
                </div>
                <div className="form-check form-check-inline padding-left-0">
                  <div className="form-check">
                    <input
                      id="physicalMode"
                      className="form-check-input"
                      type="radio"
                      name="mode"
                      value="physical"
                      onChange={handleChange}
                      checked={formData.mode === "physical"}
                    />
                    <label htmlFor="physicalMode" className="form-check-label">
                      Physical Meeting
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {formData.mode === "virtual" ? (
              <div className="mb-3">
                <label className="mb-1">Select Link Type</label>
                <span className="star-mark">*</span>
                <select
                  className="fltr-opt"
                  aria-placeholder="Select Link Type"
                  name="linkType"
                  value={formData.linkType || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "ZOOM") {
                      handledateChange("linkType", value);
                    } else {
                      setFormData((prev) => ({ ...prev, linkType: value }));
                    }
                    if (
                      value === "ZOOM" &&
                      meetingData?.singleMeetingDetails?.linkType !== "ZOOM"
                    ) {
                      setFormData((prev) => ({ ...prev, link: "" }));
                    }
                    if (
                      value === "MSTEAMS" &&
                      meetingData?.singleMeetingDetails?.linkType !== "MSTEAMS"
                    ) {
                      setFormData((prev) => ({ ...prev, link: "" }));
                    }
                    if (
                      value === "GMEET" &&
                      meetingData?.singleMeetingDetails?.linkType !== "GMEET"
                    ) {
                      setFormData((prev) => ({ ...prev, link: "" }));
                    }
                  }}
                >
                  {/* <option value="">Select Link Type</option>{" "} */}
                  {/* Corrected default value */}
                  <option value="MANUAL">My Link</option>
                  {zoomCred?.isActive === true &&
                  zoomCred?.clientId &&
                  zoomCred?.clientId !== "" &&
                  zoomCred?.accountId &&
                  zoomCred?.accountId !== "" &&
                  zoomCred?.secretToken &&
                  zoomCred?.secretToken !== "" ? (
                    <option value="ZOOM">Zoom</option>
                  ) : null}
                  {gmeetCred?.isActive === true &&
                  gmeetCred?.tokenData &&
                  gmeetCred?.tokenData?.refreshToken !== "" &&
                  gmeetCred?.tokenData?.clientId !== "" &&
                  gmeetCred?.tokenData?.secretToken !== "" ? (
                    <option value="GMEET"> Google Meet</option>
                  ) : null}
                  {msTeamsCred?.isActive === true &&
                  msTeamsCred?.tokenData &&
                  msTeamsCred?.tokenData?.accessToken !== "" &&
                  msTeamsCred?.tokenData?.refreshToken !== "" ? (
                    <option value="MSTEAMS">Microsoft Teams</option>
                  ) : null}
                </select>
                {errors.linkType && (
                  <span className="error-message">{errors.linkType}</span>
                )}
              </div>
            ) : null}
            {formData.linkType === "MANUAL" || formData.mode === "physical" ? (
              <div className="mb-3">
                <label className="mb-1">Meeting Link</label>
                {formData.linkType === "MANUAL" &&
                formData.mode === "virtual" ? (
                  <span className="star-mark">*</span>
                ) : null}
                <input
                  type="text"
                  placeholder="Enter Meeting Link"
                  name="link"
                  value={formData.link}
                  onChange={handleChange}
                  onBlur={urlFieldValidationCheck}
                  autoComplete="off"
                />
                {errors.link && (
                  <span className="error-message">{errors.link}</span>
                )}
              </div>
            ) : null}

            <div className="mb-3">
              <label className="mb-1" for="location">
                Location
              </label>
              <span className="star-mark">*</span>
              <div className="w-100 resp-grid mb-2">
                <div className="form-check form-check-inline">
                  <input
                    id="manualLocation"
                    className="form-check-input"
                    type="radio"
                    name="location"
                    value="manual"
                    onChange={handleChange}
                    checked={formData.location === "manual"}
                  />
                  <label className="form-check-label" htmlFor="manualLocation">
                    Enter Manually
                  </label>
                </div>

                <div className="form-check form-check-inline padding-left-0">
                  <div className="form-check">
                    <input
                      id="meetingRoomLocation"
                      className="form-check-input"
                      type="radio"
                      name="location"
                      value="meetingroom"
                      onChange={handleChange}
                      checked={formData.location === "meetingroom"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="meetingRoomLocation"
                    >
                      Select A Meeting Room
                    </label>
                  </div>
                </div>
              </div>

              {formData.location === "meetingroom" ? (
                <div className="mb-3">
                  <label className="mb-1">Select Unit</label>
                  <span className="star-mark">*</span>
                  <Select
                    className="fltr-opt"
                    defaultValue={selectedUnitOption}
                    name="unitId"
                    options={unitOptions}
                    onChange={handleUnitChange}
                    value={selectedUnitOption}
                    styles={customStyles}
                  />
                  {errors.unitId && (
                    <span className="error-message">{errors.unitId}</span>
                  )}
                </div>
              ) : null}

              {formData.location !== "meetingroom" ? (
                <>
                  <textarea
                    className="mt-1"
                    placeholder="Enter Location"
                    id=""
                    cols="56"
                    rows="3"
                    onChange={handleChange}
                    name="locationData"
                    value={formData.locationData}
                    onBlur={locationDetailsFieldValidationCheck}
                  ></textarea>

                  <p className="success-message">
                    {checkCharacterLeft(formData.locationData)} Characters left
                  </p>
                  {errors.locationData && (
                    <span className="error-message">{errors.locationData}</span>
                  )}
                </>
              ) : (
                <>
                  {unitId ? (
                    <div className="mb-3">
                      <label className="mb-1">Select Room</label>
                      <span className="star-mark">*</span>
                      <Select
                        className="fltr-opt"
                        defaultValue={selectedRoomOption}
                        name="roomId"
                        options={roomOptions}
                        onChange={handleRoomChange}
                        value={selectedRoomOption}
                        onBlur={meetinRoomFieldValidationCheck}
                        styles={customStyles}
                      />

                      {errors.roomId && (
                        <span className="error-message">{errors.roomId}</span>
                      )}
                    </div>
                  ) : null}
                </>
              )}
            </div>

            {errors.room && <div className="error-message">{errors.room}</div>}

            {roomErrors.room && (
              <div className="error-message">{roomErrors.room}</div>
            )}

            <div className="button-outer">
              {!meetingData.updateLoading && stateData?.isMeetingDataUpdate ? (
                <button
                  className="create-meeting-button Mom-btn"
                  type="submit"
                  disabled={isUpdateDiable}
                >
                  <p>Update</p>
                </button>
              ) : (
                <SmallLoaderButton />
              )}

              {!meetingData.updateLoading && stateData?.isMeetingDataUpdate ? (
                <button
                  type="button"
                  className="add-minutes Mom-btn"
                  onClick={(e) => {
                    setErrors({});
                    updateStepWithCheck();
                    dispatch(setErrorMessage(null));
                  }}
                >
                  <p>Next</p>
                </button>
              ) : !meetingData.updateLoading &&
                !stateData?.isMeetingDataUpdate ? (
                <button
                  className="add-minutes Mom-btn"
                  onClick={(e) => {
                    setErrors({});
                    dispatch(updateStep(1));
                    dispatch(setErrorMessage(null));
                  }}
                >
                  <p>Next</p>
                </button>
              ) : meetingData.updateLoading &&
                !stateData?.isMeetingDataUpdate ? (
                <SmallLoaderButton />
              ) : null}
            </div>

            {meetingData?.errorMessage && (
              <div className="attendee-array-error-messages mt-3">
                <ul className="error-list error-message">
                  {(Array.isArray(meetingData.errorMessage)
                    ? meetingData.errorMessage
                    : [meetingData.errorMessage]
                  ).map((error, index) => (
                    <li key={index} className="error-item">
                      {error}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </form>
      ) : meetingData.step + 1 === 2 && !meetingData.isNewMeetingPage ? (
        <>
          <AddAttendees />
        </>
      ) : meetingData.step + 1 === 3 && !meetingData.isNewMeetingPage ? (
        <>
          <AddAgendas showRemoveButton={false} />
        </>
      ) : null}
    </div>
  );
});

export default EditMeeting;
